import React, { useState, useEffect, useRef } from 'react';
import './room1.css';
import Settings from '../components/common/settings';
import LosePopup from '../components/common/lost';
import { useNavigate } from 'react-router-dom';

import scrollGif from '../assets/scroll_open_close (1).gif';
import lockedSound from '../audios/mixkit-click-error-1110.wav';
import settingsSound from '../audios/settoings.wav';

const TOTAL_TIME = 10 * 60;
const ROOM_KEY = 'room1_time';

const CLUE_TEXT =
  "if you are reading this, the truth is still hidden. Room 405 holds the first secret. Not everything in this room is what it seems.";

const Room1 = () => {
  const navigate = useNavigate();
  const [timeLeft, setTimeLeft] = useState(() => {
    localStorage.setItem(ROOM_KEY, Date.now());
    return TOTAL_TIME;
  });

  const [clueOpen, setClueOpen] = useState(false);
  const [openSettings, setOpenSettings] = useState(false);
  const [showTapeIntro, setShowTapeIntro] = useState(true);
  const [typedText, setTypedText] = useState('');
  const [showLosePopup, setShowLosePopup] = useState(false);

  const lockedAudio = useRef(null);
  const settingsAudio = useRef(null);

  useEffect(() => {
    lockedAudio.current = new Audio(lockedSound);
    settingsAudio.current = new Audio(settingsSound);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const saved = localStorage.getItem(ROOM_KEY);
      if (!saved) return;

      const elapsed = Math.floor((Date.now() - Number(saved)) / 1000);
      const remaining = Math.max(TOTAL_TIME - elapsed, 0);
      setTimeLeft(remaining);

      if (remaining === 0) {
        setShowLosePopup(true);
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => setShowTapeIntro(false), 3200);
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    if (!clueOpen) return;

    setTypedText('');
    let i = 0;

    const interval = setInterval(() => {
      setTypedText(CLUE_TEXT.slice(0, i + 1));
      i++;

      if (i >= CLUE_TEXT.length) {
        clearInterval(interval);
      }
    }, 40);

    return () => clearInterval(interval);
  }, [clueOpen]);

  const playLockedSound = () => {
    if (!lockedAudio.current) return;
    lockedAudio.current.currentTime = 0;
    lockedAudio.current.play().catch(() => {});
  };

  const playSettingsSound = () => {
    if (!settingsAudio.current) return;
    settingsAudio.current.currentTime = 0;
    settingsAudio.current.play().catch(() => {});
  };

  const openSettingsMenu = () => {
    playSettingsSound();
    setOpenSettings(true);
  };

  const closeSettingsMenu = () => {
    playSettingsSound();
    setOpenSettings(false);
  };

  const minutes = String(Math.floor(timeLeft / 60)).padStart(2, '0');
  const seconds = String(timeLeft % 60).padStart(2, '0');
  const isWarning = timeLeft <= 60;
  const fillPercent = (timeLeft / TOTAL_TIME) * 100;

  return (
    <section className="room1div">

      {showTapeIntro && (
        <div className="tapeintro">
          <div className="cautiontape tape-a" />
          <div className="cautiontape tape-b" />
          <div className="cautiontape tape-c" />
        </div>
      )}

      <div className="room1nav">
        <div />

        <div className="roomtimer">
          <span className="timerlabel">TIME REMAINING</span>

          <div className="timerdiv">
            <span className={`timerdigits ${isWarning ? 'timerwarning' : ''}`}>
              {minutes}:{seconds}
            </span>
          </div>

          <div className="timerbar">
            <div
              className="timerbartill"
              style={{
                width: `${fillPercent}%`,
                background: isWarning ? '#ff4444' : '#D4AF37',
              }}
            />
          </div>
        </div>

        <div className="settings" onClick={openSettingsMenu} />
      </div>

      <div
        className="rolledpaper"
        onClick={() => {
          playLockedSound();
          setClueOpen(true);
        }}
      />

      {clueOpen && (
        <div className="cluemodaloverlay" onClick={() => setClueOpen(false)}>
          <div
            className="scrollgifcontainer"
            onClick={(e) => e.stopPropagation()}
          >
            <img src={scrollGif} alt="Scroll Clue" className="scrollgif" />

            <div className="typewritertext">
              {typedText}
            </div>

            <button
              className="clueclosebtn"
              onClick={() => setClueOpen(false)}
            >
              ✕
            </button>
          </div>
        </div>
      )}
      <div
        className="doordiv"
        onClick={() => navigate('/dooropen')}
        style={{ cursor: 'pointer' }}
      />

      <Settings
        open={openSettings}
        onClose={closeSettingsMenu}
        onPlaySound={playSettingsSound}
        onNavigate={navigate}
      />
      <LosePopup
        open={showLosePopup}
        onRetry={() => {
          localStorage.removeItem(ROOM_KEY);
          window.location.reload();
        }}
      />

    </section>
  );
};

export default Room1;